import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import "../styles/section-chef.css";

import { useState } from "react";
import { GET, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { createLogger } from "../../utils/logger";
import Table from "../tables/table";
import { openNotificationWithIcon } from "./notification-bar";

const logger = createLogger("SelectMenu");
const SelectMenu = (props) => {
  const { lang, user } = props;
  const history = useHistory();

  const [live, setLive] = useState("no-live");

  const [foodList, setFoodList] = useState([]);

  const [foodTypeList, setFoodTypeList] = useState([]);

  const [foodType, setFoodType] = useState("");

  const [load, setLoad] = useState(false);

  useEffect(() => {
    initialData();
  }, []);

  const initialData = async () => {
    setLoad(true);
    const request_details_food = {
      type: GET,
      url: service_api,
      route: `food/get-chef-food/${user?._id}`,
      data: null,
      token: user?.refresh_token
    };

    const request_details_food_type = {
      type: GET,
      url: service_api,
      route: `food-type/get-actif`,
      data: null,
      token: null
    };

    try {
      const [response_food_list, response_food_type_list] = await Promise.all([
        MakeRequestAsync(request_details_food),
        MakeRequestAsync(request_details_food_type)
      ]);
      const food_list = decryptSingleData(response_food_list.data.food);
      const food_type_list = decryptSingleData(
        response_food_type_list.data.food_type
      );
      setFoodList(food_list);
      setFoodTypeList(food_type_list);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const deleteItem = async (food_id) => {
    setLoad(true);
    const request_details_food = {
      type: UPDATE,
      url: service_api,
      route: `food/chef-update-food/${food_id}`,
      data: {
        deleted: true
      },
      token: user?.refresh_token
    };

    try {
      await MakeRequestAsync(request_details_food);
      openNotificationWithIcon("success", t("success.item_deleted", lang));
      // Refresh the data instead of reloading the page
      initialData();
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const hideItem = async (food_id, value) => {
    setLoad(true);
    const request_details_food = {
      type: UPDATE,
      url: service_api,
      route: `food/chef-update-food/${food_id}`,
      data: {
        visible: value
      },
      token: user?.refresh_token
    };

    try {
      await MakeRequestAsync(request_details_food);

      openNotificationWithIcon(
        "success",
        t("success.item_visibility_updated", lang)
      );
      // Refresh the data instead of reloading the page
      initialData();
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="section-chef-menu-right-food">
      <div className="section-chef-menu-right-food-inside">
        <div className="section-chef-menu-right-food-inside-filter">
          <p className="filter-heading">{t("common.filters", lang)}</p>
          <div className="filter-container">
            <div className="filter-container-inner">
              <p className="filter-description">
                {t("common.you_can_filter__2", lang)}
              </p>
              <select
                className="select-address-box select-address-box-full"
                name={"foodType"}
                value={foodType}
                onChange={(e) => {
                  setFoodType(e.target.value);
                }}
              >
                <option value="">{t("forms.all_option", lang)}</option>
                {foodTypeList.map((item) => (
                  <option value={lang === "en" ? item?.eng_name : item?.name}>
                    {lang === "en" ? item?.eng_name : item?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="section-chef-menu-right-food-inside-filter section-chef-menu-right-food-inside-filter-full">
          <div className="toggle-buttons-container">
            {[
              {
                live: "no-live",
                text: t("common.draft", lang)
              },
              {
                live: "live",
                text: t("common.live_dishes", lang)
              }
            ].map((item) => (
              <div
                className={`toggle-live-btn ${
                  item?.live === live
                    ? "toggle-live-btn-active"
                    : "toggle-live-btn-inactive"
                }`}
                onClick={() => {
                  setLive(item?.live);
                }}
              >
                <p className="toggle-live-btn-text">{item?.text}</p>
              </div>
            ))}
          </div>
          <div className="action-buttons-container">
            <div
              className="btn-get-started btn-get-started-primary"
              onClick={() => {
                if (load) {
                  return;
                }
                return history.push("/chef/iam-a-chef/add-menu");
              }}
            >
              {!load && t("buttons.add_new_food", lang)}
              {load && <CircularProgress size={25} />}
            </div>
            <div
              className="btn-get-started btn-get-started-secondary"
              onClick={() => {
                if (load) {
                  return;
                }
              }}
            >
              {!load && t("common.export_csv_exce_6", lang)}
              {load && <CircularProgress size={25} />}
            </div>
          </div>
          <div className="table-wrapper-container">
            <Table
              data={foodList?.filter((item) => {
                return live === "live"
                  ? item.visible === true && item.status === true
                  : item.status === false || item.visible === false;
              })}
              deleteItem={deleteItem}
              hideItem={hideItem}
              live={live}
              chef={user}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectMenu;
